<template>
  <!-- <view>
    <Index
      wx:if="{{show}}"
      pageConfig="{{pageConfig}}"
      info="{{info}}"
    />
    <block wx:if="{{__mpx_mode__ === 'wx'}}"><Loading wx:if="{{loading}}" /></block>
  </view> -->
</template>

<script>
import { createPage } from '@mpxjs/core'
import { query, goTo } from '@didi/webx-js'
// import viewsMixin from '../../lib/mixin/views-v3'
// import { props } from '../../editor/hy/model/props'
createPage({
  // data: {
  //   props,
  // },
  // mixins: [ viewsMixin() ],
  onLoad() {
    this.redirectPage()
  },
  methods: {
    redirectPage() {
      const { dchn, source_id, dsi } = query()
      goTo({
        path: `/webx/entry/ut?dchn=${dchn}&source_id=${source_id}&dsi=${dsi}`,
        extParams: {
          moveType: 1,
        },
      })
    },
  },
})
</script>
<script name="json">
const config = {
  "navigationBarTitleText": "",
  "backgroundColor": "#ffffff",
  // "usingComponents": {
  //   // "Index": "../../editor/hy//index",
  //   "IndexPlaceholder": "./index-placeholder.mpx"
  // },
}
// if (__mpx_mode__ === 'wx') {
//   config.usingComponents.Loading = '../../components/common/loading.mpx'
// }
module.exports = config
</script>
<style lang="stylus" scoped>
</style>
